import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';
import { withViewModelService, ViewModelForm } from 'gw-portals-viewmodel-react';
import { InputField, CurrencyField, DropdownSelectField, RadioButtonField } from '@jutro/components';
import PropTypes from 'prop-types';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import { withValidation, validationPropTypes } from 'gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import { Loader, ModalNextProvider } from '@jutro/components';
import { GatewayBillingService } from 'gw-capability-gateway-billing';
import { ServiceManager } from '@jutro/services';
import PaymentStyles from './PaymentMethodComponent.module.scss';
import metadata from './PaymentMethodComponent.metadata.json5';
import messages from './PaymentMethodComponent.messages';
import { messages as commonMessages } from 'gw-platform-translations';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';

class PaymentMethodComponent extends Component {
    static contextType = TranslatorContext;

    static propTypes = {
        model: PropTypes.shape({
            paymentMethod: PropTypes.string,
            bankAccountData: PropTypes.shape({}),
            creditCardData: PropTypes.shape({})
        }),
        viewModelService: PropTypes.shape({
            create: PropTypes.func
        }).isRequired,
        onCallback: PropTypes.func.isRequired,
        xCenter: PropTypes.string.isRequired,
        title: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        hideTitle: PropTypes.bool,
        onCancel: PropTypes.func.isRequired,
        nextLabel: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        previousLabel: PropTypes.shape({
            id: PropTypes.string.isRequired,
            defaultMessage: PropTypes.string.isRequired
        }),
        isSetupPayment: PropTypes.bool,
        isCustomFooter: PropTypes.bool,
        isDisabled: PropTypes.bool,
        isSelectedInvoiceAmount: PropTypes.bool,
        ...validationPropTypes
    };

    static defaultProps = {
        model: undefined,
        title: undefined,
        hideTitle: false,
        nextLabel: undefined,
        previousLabel: undefined,
        isSetupPayment: false,
        isCustomFooter: false,
        isDisabled: false,
        isSelectedInvoiceAmount: false
    }

    state = {
        paymentMethod: '',
        accountCreditCardVM: {},
        accountBankDetailVM: {},
        showValidationErrors: false,
        paymentInstrumentDto: {},
        instituteNumber: '',
        iframeUrl: '',
        loadIframeUrl: false,
        paymentList: [],
        addCreditCardInstrument: false,
        addBankInstrument: false,
        monURL: {},
        instituteList: [],
        selectedBankValue: {},
        cardError: '',
        token: '',
        isLoading: false,
        changePaymentMethodValues: [],
        editMode: false,
        selectedPayUsing: '',
        paymentMethodList_EY: [],
        selectedOverridePayment: '',
        bankInstitueDataTableVisible: false

    };


    localeService = ServiceManager.getService('locale-service');
    componentDidMount = () => {
        let { accountCreditCardVM, accountBankDetailVM } = this.state;
        const { viewModelService, xCenter, model, authHeader, billingData, isEdit } = this.props;
        const initValue = {
            paymentMethod: '',
            bankAccountData: {},
            creditCardData: {}
        };
        this.setState({ editMode: isEdit });
        const accountNumber = billingData.getAccountDetails.accountNumber;
        let paymentInstrumentDto = viewModelService.create(
            initValue,
            xCenter,
            'edge.capabilities.billing.dto.PaymentInstrumentDTO'
            );
        const configuredPayment = _.get(billingData, "paymentGroup.paymentInstrument");

        GatewayBillingService.getAccountPaymentInstruments(accountNumber, authHeader)
            .then((list) => {
                const values = list.filter(e => e != null);
                const changePaymentMethodValues = values.map(value => {
                    return { code: value.publicID, name: value.displayName };
                });
                
                if(configuredPayment) {
                   const existingPayment =  values.find(v =>v.publicID === configuredPayment.publicID );
                   const paymentsMethod =  {code:existingPayment.publicID, name:existingPayment.displayName }
                   this.setState({selectedOverridePayment: paymentsMethod});
                   paymentInstrumentDto.value = existingPayment;
                   _.set(paymentInstrumentDto,'overrideDayOfMonth.value', configuredPayment.overrideDayOfMonth);
                   
                }

                // const paymentMethodList = values[0].paymentMethodList_EY.map(method => {
                //     var res = method.split("::");
                //     return { code: res[0], name: res[1] };
                // });
                this.setState({ changePaymentMethodValues: changePaymentMethodValues,
                    paymentList: values});
                    // paymentMethodList_EY: paymentMethodList});

            })
            .catch((error) => {
                ModalNextProvider.showAlert({
                    title: messages.instituteSearchError,
                    message: messages.instituteSearchErrorDetails,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
        this.setState({
            // paymentMethod,
            // accountCreditCardVM,
            // accountBankDetailVM,
            paymentInstrumentDto
        });
    };

    isModelValid = (viewModel) => {
        return viewModel.aspects
            ? viewModel.aspects.valid && viewModel.aspects.subtreeValid
            : false;
    };

    handlePaymentOptions = (data) => {
        this.setState({
            paymentMethod: data,
            showValidationErrors: false
        });
    };

    writeValue = (value, path) => {
       
        const { paymentInstrumentDto } = this.state;
        _.set(paymentInstrumentDto, path, value);
        this.setState({paymentInstrumentDto:paymentInstrumentDto})
    };

    payNowClicked = () => {
        const { onCallback } = this.props;
        const {paymentInstrumentDto } = this.state;
        const paymentVM = paymentInstrumentDto;
        if (paymentVM.paymentMethod.value.code === 'responsive') {
            _.set(paymentVM, "bankAccountData.value", null);
            _.set(paymentVM, "creditCardData.value", null);
        }
        if (paymentVM.paymentMethod.value.code === 'ach') {
            _.set(paymentVM, "creditCardData.value", null);
        } 
        if (paymentVM.paymentMethod.value.code === 'preauthorizedCC_EY') {
            _.set(paymentVM, "bankAccountData.value", null);
        }
        const isComponentValid = this.isModelValid(paymentVM);

        if (!isComponentValid) {
            this.setState({
                showValidationErrors: true
            });
            return;
        }

        if (onCallback) {
            onCallback(paymentVM, paymentVM.paymentMethod.value.code);
        }
    };

    getPayUsingDataTableCell = (item, index, props) => {
        const path = props.path;
        var selectedPaymentPlan = item.publicID;
        if (path == 'selectedPaymentInstrument_EY') {
            return (
                <RadioColumn
                    id={index + path}
                    textAlign="left"
                    header={item.displayName}
                    option={generateDataForRadioButton}
                    cellClassName={styles.paymentListTableCell}
                    value={selectedPaymentPlan}
                    onValueChange={handleValueChange}
                />
            )
        }
        else if (path == 'displayName') {
            return (
                <InputField
                    dataType="string"
                    id={index + path}
                    value={item.displayName}
                    readOnly={true}
                />
            )
        }
        else if (path == 'instituteName') {
            return (
                <InputField
                    dataType="string"
                    id={index + path}
                    value={item.bankName}
                    readOnly={true}
                />
            )
        }
        else if (path == 'InstitutionNumber') {
            return (
                <InputField
                    dataType="string"
                    id={index + path}
                    value={item.institutionNumber}
                    readOnly={true}
                />
            )
        }


    };

    generateDataForRadioButton = (item) => {
        return {
            name: item.displayName,
            code: item.publicID
        };
    };

    generateDataForInstitureRadioButton = (item) => {
        return {
            name: item.bankName,
            code: item.institutionNumber + '-' + item.bankName
        };
    };


    doMonerisSubmit = () => {
        const { paymentInstrumentDto ,monURL} = this.state;
        if (!(paymentInstrumentDto.creditCardData.aspects.valid)) {
            ModalNextProvider.showAlert({
                title: messages.creditCardError,
                message: messages.creditCardEmptyError,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            return;
        }
        var monFrameRef = document.getElementById('monerisFrame').contentWindow;
        // monFrameRef.postMessage('tokenize','https://esqa.moneris.com/HPPtoken/index.php');
      const data =   monFrameRef.postMessage('tokenize', monURL);
        if (window.addEventListener) {
            window.addEventListener("message", this.respMsg, false);
            //document.getElementById('CreateSamplePaymentInstrument-5').style.visibility = "hidden";
        }
        else {
            if (window.attachEvent) {
                window.attachEvent("onmessage",this. respMsg);
            }
        }
        return false;
    };

    addPaymentInstrument = () => {
        const { paymentInstrumentDto } = this.state;
        if (this.isCreditCardVisible()) {
            this.setState({ addBankInstrument: false })
            this.getIframeUrl();
            this.setState({ addCreditCardInstrument: true })
        } else if (this.isBankAccountVisible()) {
            this.setState({ addBankInstrument: true })
            this.setState({ addCreditCardInstrument: false })
        }
    };


    /**Function called at iFrame response */
    respMsg =  (e) =>  {
        const { paymentInstrumentDto } = this.state;
        // if (!(paymentInstrumentDto.creditCardData.aspects.valid)) {
        //     return;
        // }

        var respData = eval("(" + e.data + ")");

        //$scope.cardError = '';
        //$scope.token = '';
        this.setState({ cardError: '' });
        this.setState({ token: '' });
        // updateToken('');
        if (respData.responseCode[0] == '001') {
            /**Todo change below to scope hide and show */
            this.setState({ loadIframeUrl: false })
            this.setState({ addCreditCardInstrument: false })
            //ToDo: token set
            paymentInstrumentDto.creditCardData.token_EY.value = respData.dataKey;
            //this.setState({ addCreditCardInstrument: false })
            //this.addCreditCardPaymentInstrument();
        }
        var errorDesc = "";
        for (var i = 0; i < respData.responseCode.length; i++) {
            if (respData.responseCode[i] != "") {
                switch (respData.responseCode[i]) {
                    case "940":
                    case "941":
                    case "942":
                        errorDesc = errorDesc + "Validation failed. Please retry after checking the card details";
                        break;
                    case "943":
                        errorDesc = errorDesc + "Card Number is invalid";
                        break;
                    case "944":
                        errorDesc = errorDesc + "Invalid expiration date (mmyy, must be current month or in the future)";
                        break;
                    case "945":
                        errorDesc = errorDesc + "Invalid CVV data (not 3 digits)";
                        break;
                    default:
                }
                if (respData.responseCode.length > 1) {
                    errorDesc = errorDesc + " ; ";
                }
                if (respData.responseCode.length >= 1 && errorDesc != "") {
                    this.setState({ addCreditCardInstrument: false })
                    ModalNextProvider.showAlert({
                        title: messages.creditCardError,
                        message: errorDesc,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop);
                }
            }
        }
        /**Todo display error in popup, add hide and show */
        // $scope.cardError = errorDesc;
        // $scope.token = respData.dataKey;
    };


    getIframeUrl = () => {
        const { authHeader } = this.props;
        const { paymentInstrumentDto } = this.state;
        this.setState({ loadIframeUrl: false });
        var modeOfPayment = paymentInstrumentDto.creditCardData?.modeOfReceiving_EY?.value?.code ? paymentInstrumentDto.creditCardData?.modeOfReceiving_EY?.value?.code : 'paperformemail';
        LoadSaveService.getMonerisRequestURL_EY(modeOfPayment, authHeader).then(paymentUrl_EY => {
            this.setState({ iframeUrl: paymentUrl_EY })
            var index = paymentUrl_EY.indexOf('?');
            this.setState({ monURL: paymentUrl_EY.substring(0, index) })
            this.setState({ loadIframeUrl: true });
            this.setState({ addCreditCardInstrument: true });
        }).catch(() => {
            ModalNextProvider.showAlert({
                title: messages.paymentStatus,
                message: messages.paymentAddFailure,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).catch(_.noop);
            this.setState({ loadIframeUrl: false });
            this.setState({ addCreditCardInstrument: false });
            this.setState({ iFrameUrl: '' })
        });
    };

    searchBankInstituteEY = () => {
        this.setState({ instituteList: [] });
        const { instituteNumber,bankInstitueDataTableVisible } = this.state
        const { authHeader } = this.props;
        GatewayBillingService.searchBankInstitute_EY(instituteNumber, " ", authHeader)
            .then((list) => {
                this.setState({ instituteList: list, bankInstitueDataTableVisible:true });
            })
            .catch((error) => {
                ModalNextProvider.showAlert({
                    title: messages.instituteSearchError,
                    message: messages.instituteSearchErrorDetails,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok
                }).catch(_.noop);
            });
    };

    handleCreditCardModeChange = (value) => {
            const { paymentInstrumentDto } = this.state;
            _.set(paymentInstrumentDto,'creditCardData.modeOfReceiving_EY.value',  value );
            this.setState({ addBankInstrument: false });
            this.getIframeUrl();
            this.setState({ addCreditCardInstrument: true });
        }
    
    renderCreditCardTableTable = () => {
        const noRecordsMessage = 'No records found';
        const { iframeUrl } = this.state;
        return (
            <>
                <div>
                    <iframe
                        id="monerisFrame"
                        title="moneris payment"
                        className={PaymentStyles.gwMonerisPayment}
                        frameBorder="0"
                        allowFullScreen
                        width="100%"
                        height="100%"
                        //src="https://www.youtube.com"
                        src={iframeUrl}
                    //src="https://esqa.moneris.com/HPPtoken/index.php?id=htB4HNFH85X9F7S&pmmsg=true&css_body=background:white;&css_textbox=border-width:2px;margin-bottom:10px;&css_textbox_pan=width:140px;&css_input_label=float:left;padding-right:10px;width:200px;&pan_label=Credit Card Number&exp_label=Expiry Date(MMYY)&&enable_exp=1&css_textbox_exp=width:40px;&display_labels=1"
                    />
                </div>
            </>
        );
    };

    handleInstitueValueChange = (value, item, prop) => {
        const { paymentInstrumentDto } = this.state;
        this.setState({ selectedBankValue: value })
        var res = value.split("-");
        _.set(paymentInstrumentDto,'bankAccountData.institutionNumber.value',  res[0] );
        _.set(paymentInstrumentDto,'bankAccountData.bankName.value',res[1]);
        this.setState({ paymentInstrumentDto: paymentInstrumentDto,bankInstitueDataTableVisible:false})

    }

    handleValueChange = (value, item, prop) => {
        const { paymentInstrumentDto, paymentList, selectedPayUsing } = this.state;
        this.setState({ selectedPayUsing: value })
        const payItem = paymentList.find(v => v.publicID === value)
        const overrideDayOfMonth = paymentInstrumentDto.overrideDayOfMonth.value;
        paymentInstrumentDto.value = payItem
        paymentInstrumentDto.overrideDayOfMonth.value = overrideDayOfMonth;
        this.setState({ paymentInstrumentDto: paymentInstrumentDto });
    }

    handleInstituteNumberChange = (value) => {
        this.setState({ instituteNumber: value });
    }

    handleAddNewPaymentClick = () => {
        const { viewModelService, xCenter} = this.props;
        const { editMode,paymentInstrumentDto } = this.state;
        this.setState({ editMode: false });
        const overrideDayOfMonth = paymentInstrumentDto.overrideDayOfMonth.value;
        const initValue = {
            paymentMethod: '',
            bankAccountData: {},
            creditCardData: {}
        };
        let paymentInstrumentDtoNew = viewModelService.create(
            initValue,
            xCenter,
            'edge.capabilities.billing.dto.PaymentInstrumentDTO'
            );
        paymentInstrumentDtoNew.overrideDayOfMonth.value = overrideDayOfMonth;
        this.setState({ paymentInstrumentDto: paymentInstrumentDtoNew });
    }

    handleChangePaymentMethodValues = (value) => {
        const { paymentInstrumentDto, paymentList, selectedOverridePayment } = this.state;
        this.setState({ selectedOverridePayment: value });
        const payItem = paymentList.find(v => v.publicID === value)
        const overrideDayOfMonth = paymentInstrumentDto.overrideDayOfMonth.value;
        paymentInstrumentDto.value = payItem
        paymentInstrumentDto.overrideDayOfMonth.value = overrideDayOfMonth;
        this.setState({ paymentInstrumentDto: paymentInstrumentDto });
    }

    getWithdrawalDayOfMonth = () => {
        const dayOfMonth = [];
        for (let i = 1; i <= 31; i++) {
            dayOfMonth.push({ code: i, name: i });
        }
        return dayOfMonth;
    }

    isCreditCardVisible = () => {
        const { paymentInstrumentDto } = this.state;
        let isCreditCardSelect = false;
        if (paymentInstrumentDto.hasOwnProperty('paymentMethod')) {
            isCreditCardSelect = paymentInstrumentDto.paymentMethod.value === undefined ?
                false : paymentInstrumentDto.paymentMethod.value.code === 'preauthorizedCC_EY'
        }
        return isCreditCardSelect;
    }


    isBankAccountVisible = () => {
        const { paymentInstrumentDto } = this.state;
        let isCreditCardSelect = false;
        if (paymentInstrumentDto.hasOwnProperty('paymentMethod')) {
            isCreditCardSelect = paymentInstrumentDto.paymentMethod.value === undefined ?
                false : paymentInstrumentDto.paymentMethod.value.code === 'ach'
        }
        return isCreditCardSelect;
    }

    getPayUsingTableData = () => {
        const { paymentList } = this.state;
        if (paymentList.length == 0) {
            return paymentList;
        }
        if (this.isBankAccountVisible()) {
            return paymentList.filter(v => v.paymentMethod === 'ach')
        }
        if (this.isCreditCardVisible()) {
            return paymentList.filter(v => v.paymentMethod === 'preauthorizedCC_EY')

        }
        return null

    }
    render() {
        const translator = this.context;
        const {
            paymentMethod,
            showValidationErrors,
            paymentInstrumentDto,
            loadIframeUrl,
            paymentList,
            instituteNumber,
            instituteList,
            bankInstitueDataTableVisible,
            selectedBankValue,
            addCreditCardInstrument,
            addBankInstrument,
            changePaymentMethodValues,
            editMode,
            selectedPayUsing,
            paymentMethodList_EY,
            selectedOverridePayment
        } = this.state;
        const paymentVM = paymentInstrumentDto;
        const {
            title, nextLabel, previousLabel, onCancel, isCustomFooter, isDisabled,
            isSetupPayment, hideTitle, setComponentValidation, isSelectedInvoiceAmount,
            isEdit
        } = this.props;

        const isComponentValid = this.isModelValid(paymentVM);
        const overrides = {
            '@field': {
                showOptional: true,
                labelPosition: 'left'
            },
            automaticPaymentMethod: {
                visible: isSetupPayment,
                value: translator(messages.bankAccountSource)
            },
            paymentOptions: {
                // value: paymentMethod,
                labelPosition: 'left',
                visible: !isSetupPayment
            },
          
            payNow: {
                onClick: this.payNowClicked,
                content: translator(nextLabel) || translator(messages.paymentComponentBuyNow),
                //   disabled: isComponentValid
            },
            paymentOptionsTitle: {
                content: translator(title) || translator(messages.paymentMethod),
                visible: !hideTitle
            },
            cancel: {
                content: translator(previousLabel) || translator(messages.cancel)
            },
            buttonContainer: {
                className: cx(PaymentStyles.paymentButtonFooter, {
                    [PaymentStyles.paymentCustomFooter]: isCustomFooter
                })
            },

            withdrawalDayOfMonth: {
                availableValues: this.getWithdrawalDayOfMonth(),
                required: true,
                showRequired: true

            },

            changePaymentMethod: {
                availableValues: changePaymentMethodValues,
                onValueChange: this.handleChangePaymentMethodValues,
                value: selectedOverridePayment
            },

            MonerisCreditCardDiv: {
                visible: addCreditCardInstrument
            },

            bankAccountDetailsCard: {
                visible: addBankInstrument
            },
            creditCardPayment: {
                content: this.renderCreditCardTableTable(),
                visible: loadIframeUrl
            },
            // paymentMethod: {
            //     availableValues: paymentMethodList_EY,
            // },
            addPayUsing: {
                onClick: this.addPaymentInstrument
            },
            payUsingDataTable: {
                data: this.getPayUsingTableData()
            },
            CardPaymentDiv: {
                visible: true
            },
            paymentCheckBox: {
                option: this.generateDataForRadioButton,
                value: selectedPayUsing,
                onValueChange: this.handleValueChange
            },
            searchInstitueInput: {
                value: instituteNumber
            },
            SearchInstituteButton: {
                onClick: this.searchBankInstituteEY
            },
            bankInstitueDataTable: {
                data: instituteList,
                visible: bankInstitueDataTableVisible
            },
            instituteCheckBox: {
                option: this.generateDataForInstitureRadioButton,
                value: selectedBankValue,
                onValueChange: this.handleInstitueValueChange
            },
            changePaymentMethodDiv: {
                visible: editMode
            },
            paymentMethodDetailsDiv: {
                visible: !editMode
            },
            addNewPayment: {
                onClick: this.handleAddNewPaymentClick
            },
            CrediCardModeofPayToggle:{
                onValueChange: this.handleCreditCardModeChange
            }
        };

        const resolvers = {
            resolveClassNameMap: PaymentStyles,
            resolveCallbackMap: {
                handlePaymentOptions: this.handlePaymentOptions,
                getPayUsingDataTableCell: this.getPayUsingDataTableCell,
                doMonerisSubmit: this.doMonerisSubmit,
                handleInstituteNumberChange: this.handleInstituteNumberChange,
                onCancel: onCancel
            }
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.componentContent, paymentVM, id, path, overrides);
        };

        return (
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={paymentVM}
                showErrors={showValidationErrors}
                overrideProps={overrides}
                resolveValue={readValue}
                onValidationChange={setComponentValidation}
                onValueChange={this.writeValue}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
            />
        );
    }
}

export default withValidation(withViewModelService(PaymentMethodComponent));
